import ApiService from '@shared/services/api.service';

const PollingHistoryService = {
  fetchListBaselineHistory: async (page, itemsPerPage, querySearch, userId = null, tagIds = []) => {
    let url = `/baselines?page=${page}&items_per_page=${itemsPerPage}&q=${querySearch}`;
    if (userId) url += `&user_id=${userId}`;
    if (Array.isArray(tagIds) && tagIds.length > 0) {
      url += `&` + tagIds.map(id => `tag_ids[]=${encodeURIComponent(id)}`).join('&');
    }
    return ApiService.get(url);
  },
  fetchListVerifyHistory: async (page, itemsPerPage, querySearch, startDate, endDate) => {
    const queryValue = {
      page,
      items_per_page: itemsPerPage,
      q: querySearch,
      start_date: startDate,
      end_date: endDate
    };
    const urlSearchParams = Object.keys(queryValue).reduce((resultSearchParams, key) => {
      if (queryValue[key]) {
        resultSearchParams.append(key, queryValue[key]);
      }
      return resultSearchParams;
    }, new URLSearchParams(''));
    return ApiService.get(`/verify_records?${urlSearchParams.toString()}`);
  },
  fetchDetailVerify: async (id) => {
    return ApiService.get(`/verify_records/${id}`);
  }
};

export default PollingHistoryService;
